function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';

import FormLabel from '@material-ui/core/FormLabel';
import FormGroup from '@material-ui/core/FormGroup';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

import { transformArrayToString } from '../../utils/arrayUtils';

function CheckboxesGroupWidget(props) {
    function selectValue(value, selected, all) {
        var at = all.indexOf(value);
        var updated = selected.slice(0, at).concat(value, selected.slice(at));
        // As inserting values at predefined index positions doesn't work with empty
        // arrays, we need to reorder the updated selection to match the initial order
        return Array.from(updated).sort(function (a, b) {
            return all.indexOf(a) > all.indexOf(b);
        });
    }

    function deselectValue(value, selected) {
        return selected.filter(function (v) {
            return v !== value;
        });
    }

    var label = props.label,
        value = props.value,
        readonly = props.readonly,
        disabled = props.disabled,
        autofocus = props.autofocus,
        onBlur = props.onBlur,
        onFocus = props.onFocus,
        options = props.options,
        _onChange = props.onChange,
        schema = props.schema,
        formContext = props.formContext,
        registry = props.registry,
        otherProps = _objectWithoutProperties(props, ['label', 'value', 'readonly', 'disabled', 'autofocus', 'onBlur', 'onFocus', 'options', 'onChange', 'schema', 'formContext', 'registry']);

    var title = schema.title;
    var enumOptions = options.enumOptions,
        inline = options.inline;


    return React.createElement(
        FormControl,
        { component: 'fieldset' },
        React.createElement(
            FormLabel,
            { component: 'legend' },
            label || title
        ),
        React.createElement(
            FormGroup,
            null,
            enumOptions.map(function (option, index) {
                var checked = value && value.indexOf(option.value) !== -1;

                return React.createElement(FormControlLabel, {
                    key: index,
                    disabled: schema.disabled || readonly,
                    value: option.value,
                    label: option.label,
                    control: React.createElement(Checkbox, {
                        checked: checked,
                        onChange: function onChange(event) {
                            var all = enumOptions.map(function (_ref) {
                                var value = _ref.value;
                                return value;
                            });
                            var newValue = event.target.checked ? selectValue(option.value, value, all) : deselectValue(option.value, value);

                            _onChange(newValue);
                        },
                        value: transformArrayToString(value)
                    })
                });
            })
        )
    );
}

CheckboxesGroupWidget.defaultProps = {
    autofocus: false,
    options: {
        inline: false
    }
};

CheckboxesGroupWidget.propTypes = process.env.NODE_ENV !== "production" ? {
    schema: PropTypes.object.isRequired,
    id: PropTypes.string.isRequired,
    options: PropTypes.shape({
        enumOptions: PropTypes.array,
        inline: PropTypes.bool
    }).isRequired,
    value: PropTypes.any,
    required: PropTypes.bool,
    readonly: PropTypes.bool,
    disabled: PropTypes.bool,
    multiple: PropTypes.bool,
    autofocus: PropTypes.bool,
    onChange: PropTypes.func
} : {};

export default CheckboxesGroupWidget;